/** Explore's view keys, as they ride in a link (`stateToSearch`). */
export const EXPLORE_KEYS = ["xv", "xp", "xf", "xt", "xs", "xfl", "xsh", "xo", "xval"] as const;
/** A page's overlay pane in its link: the open part, what it points at, and Explore's view. */
const PANE_KEYS = ["pane", "at", ...EXPLORE_KEYS];

export type PaneSearch = Record<string, string>;

/** The pane's keys from a link, as text (the router reads `1` as a number). */
export function parsePaneSearch(s: Record<string, unknown>): PaneSearch {
  return Object.fromEntries(
    PANE_KEYS.flatMap((k) => {
      const v = s[k];
      if (v === undefined || v === null || v === "") return [];
      const text = typeof v === "string" ? v : JSON.stringify(v);
      return text.length <= 600 ? [[k, text]] : [];
    }),
  );
}

/** Explore's view out of a page's link. */
export function exploreOf(q: PaneSearch): Record<string, string> {
  return Object.fromEntries(
    Object.entries(q).filter(([k]) => (EXPLORE_KEYS as readonly string[]).includes(k)),
  );
}
